import React from 'react';
import { useTranslation } from 'react-i18next';
import { TASK_BOARD_STATUSES, type TaskBoardStatus } from '../../utils/taskHelpers';

interface TaskStatusSwitcherProps {
  activeStatus: TaskBoardStatus;
  onChange: (status: TaskBoardStatus) => void;
}

const TaskStatusSwitcher: React.FC<TaskStatusSwitcherProps> = ({
  activeStatus,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <div className="tasks-status-switcher" role="tablist" aria-label={t('tasks_status_filter')}>
      {TASK_BOARD_STATUSES.map((status) => (
        <button
          key={status}
          type="button"
          role="tab"
          aria-selected={activeStatus === status}
          className={`tasks-status-switcher-btn${activeStatus === status ? ' active' : ''}`}
          onClick={() => onChange(status)}
        >
          {t(`tasks_status_${status}`)}
        </button>
      ))}
    </div>
  );
};

export default TaskStatusSwitcher;
